import { GenerateOTPRequest } from './generateotprequest';
import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { APIImpl, GET } from '../../api';

export class GenerateOTPAPI extends APIImpl<GenerateOTPRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/generate-otp
        return "generate-otp";
    }
    
    getRequestData()
    {
        // return "msisdn=95"+ this.getRequest().getGenerateOTPRequest().getMsisdn()  +"&"+
        // "language="+ this.getContext().getUserContext().getLanguage();
    }

    getHttpHeaders():string
    {
            let baseHeaders = super.getHttpHeaders();
            let specificSearchToneHeader = {
                // this.getRequest().getSpecificSearchToneRequest().getSearchKey().replace(/ /g, "/\/\ ")
                "msisdn": this.getRequest().getGenerateOTPRequest().getMsisdn(),
                "language" :this.getContext().getUserContext().getLanguage()
            } as any;
            let combinedHeaders = Object.assign(specificSearchToneHeader, baseHeaders);
            return combinedHeaders;
    }
       
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/otp/generateotp/generateotpapi.tsx